<template>
  <router-view/>
</template>

<style lang="scss">
@import "~@/assets/scss/Base.scss";
</style>
